import React, { useContext, useEffect, useState, useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import StateContext from "../../contexts/StateContext";
import DispatchContext from "../../contexts/DispatchContext";

import DataFetcher from "../../utils/DataFetcher";
import LoadingIndicator from "../elements/LoadingIndicator";
import { renderLicencePie, renderLicenceTable, dispError } from "../../utils/Tools";

function Overview(props) {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);
  const history = useHistory();
  const [data, setData] = useState(null);

  const getData = useCallback(() => {
    DataFetcher.fetch("/overview")
      .then(response => {
        if (!response.success) {
          appDispatch(dispError(response.msg));
          return history.push("/");
        }
        return setData(response.data);
      })
      .catch(error => {
        console.error(error);
        return history.push("/");
      });
  }, [appDispatch, history]);

  useEffect(() => {
    if (!data) {
      getData();
    }
  }, [appState, data, getData]);

  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  const renderContent = () => {
    let injection = "";
    // if (appState.user.navType === "super-admin") injection = " aller Mandanten";
    // if (appState.user.navType.includes("mandant")) injection = " aller Institutionen";
    return (
      <>
        <h2 className="title is-4">Herzlich Willkommen im Adminbereich des KC21!</h2>
        <p>
          Die Übersicht zeigt Ihnen den aktuellen Status der Lizenzen{injection}.<br />
          Alle Funktionen des Adminbereichs sind im <Link to="/download">Benutzerhandbuch</Link> erläutert.
        </p>
        {appState.user.navType === "super-admin" && (
          <p>
            Anzahl der Mandanten: <strong>{data.clients}</strong>
          </p>
        )}
        {appState.user.navType.includes("mandant") && data.hasOwnProperty("institutions") && (
          <p>
            Anzahl der Institutionen: <strong>{data.institutions}</strong>
          </p>
        )}
        {data.licences && Boolean(data.licences.total) && (
          <div className="licences-box">
            <p className="title is-5">Lizenzen{injection}</p>
            <div className="field field-body">
              {renderLicencePie(data.licences)}
              <div className="licence-table">
                {renderLicenceTable(data.licences)}
                {Boolean(data.licences.expire) && (
                  <p>
                    <span className="tag is-light">Abgelaufene Lizenzen: {data.licences.expired}</span>
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
        {process && process.env && process.env.NODE_ENV === "development" && <pre>{JSON.stringify(appState, null, 2)}</pre>}
      </>
    );
  };

  return (
    <main className="start">
      <h1 className="title">Übersicht</h1>
      {!data && <LoadingIndicator />}
      {data && renderContent()}
    </main>
  );
}
export default Overview;
